import { z } from "zod";

export const addressSchema = z.object({
  address: z.string().nullable(),
  lat: z.number().optional().nullable(),
  long: z.number().optional().nullable(),
  zipCode: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
});

export const defaultAddressValues = {
  address: "",
  lat: null,
  long: null,
  zipCode: null,
  city: null,
  country: null,
};

export const requiredAddressSchema = addressSchema.refine((data) => {
  return data.address && data.lat && data.long;
});

export const requiredCoordsAddressSchema = addressSchema.refine((data) => {
  return data.lat && data.long;
});

export type AddressForm = z.infer<typeof addressSchema>;
